import { Component } from '@angular/core';
import { ApisService } from '../../services/apis.service';

@Component({
    selector: 'app-loader',
    imports: [],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  isloading:boolean =false
  constructor(private apis:ApisService){}
  ngOnInit(){
    this.apis.loading$.subscribe(element=>{
      this.isloading=element
      console.log(element)
    })
  }
}
